import React, { Component } from 'react'
import "../../styles/SolicitarPortabilidad.scss";
import {
    Button,
} from "@material-ui/core";
import CompromisoDeudaLineasComponent from './CompromisoDeudaLineasComponent';
import appStore from '../../stores/AppStore';

const NO_ESPECIFICADO = 'N/A';
const SI = 'SI';
export default class CompromisoDeudaComponent extends Component {

    constructor(props) {
        super(props);
        let datosLineas = {
            montoMaximoDeuda: 0,
            tieneProducto: NO_ESPECIFICADO,
            numeroProductos: 0,
            montosProductos: [],
            compromisoProductos: NO_ESPECIFICADO
        };
        let datosTarjetas = {
            montoMaximoDeuda: 0,
            tieneProducto: NO_ESPECIFICADO,
            numeroProductos: 0,
            montosProductos: [],
            compromisoProductos: NO_ESPECIFICADO
        };
        const productoSeleccionado = appStore.solicitarNuevaPortalidadStore.buscarFamiliaEnBolsaPorNemo(props.tipoProducto);
        if (productoSeleccionado &&
            productoSeleccionado.compromisoDeuda &&
            productoSeleccionado.compromisoDeuda.lineas) {
            datosLineas = productoSeleccionado.compromisoDeuda.lineas;
        }
        if (productoSeleccionado &&
            productoSeleccionado.compromisoDeuda &&
            productoSeleccionado.compromisoDeuda.tarjetas) {
            datosTarjetas = productoSeleccionado.compromisoDeuda.tarjetas;
        }
        this.state = {
            lineasValidas: false,
            tarjetasValidas: false,
            datosLineas: datosLineas,
            datosTarjetas: datosTarjetas

        };
    }


    onContinuar = () => {
        if (this.props.onContinuar) {
            this.props.onContinuar(this.state.datosTarjetas, this.state.datosLineas);
        }
    }


    onValidationLineas = (value, datosLineas) => {
        if (value) {
            this.setState({ lineasValidas: value, datosLineas: datosLineas });
        } else {
            this.setState({ lineasValidas: value });
        }
    }

    onValidationTarjetas = (value, datosTarjetas) => {
        if (value) {
            this.setState({ tarjetasValidas: value, datosTarjetas })
        } else {
            this.setState({ tarjetasValidas: value })
        }

    }

    puedeContinuar = () => {
        const datosValidos = (this.state.lineasValidas && this.state.tarjetasValidas);
        let result = datosValidos;
        if (datosValidos && this.props.requerido) {
            result = this.state.datosLineas.tieneProducto === SI || this.state.datosTarjetas.tieneProducto === SI;
        }
        return result;
    }
    render() {
        return (
            <div>
                <CompromisoDeudaLineasComponent datosProductos={this.state.datosTarjetas} onValidation={this.onValidationTarjetas} nombreProducto={"Tarjeta"} />
                <CompromisoDeudaLineasComponent datosProductos={this.state.datosLineas} onValidation={this.onValidationLineas} nombreProducto={"Línea"} />
                <div className="botones">
                    <Button color="primary" id="btnVerifica" className="btnRipley" fullWidth={true}
                        onClick={this.onContinuar} disabled={!this.puedeContinuar()}>Continuar </Button>
                </div>
            </div>
        )
    }
}
